export default [
  {
    id: 'LE1',
    title: 'Familien: Verteilung, Kommunikation und Mobilit&auml;t',
    items: [
      {
        type: 'pdf',
        body: 'Übung „Meine Wurzeln“ aus dem Integrationsprojekt KIWI „Kinder und Jugendliche Willkommen“ der Hilfsorganisation CARE Deutschland-Luxemburg e. V.',
        url: '/downloads/1.1.1.Meine_Wurzeln.pdf',
      },
      {
        type: 'link',
        body: 'Bestellmöglichkeit für eine kostenfreie Europakarte bei der Bundeszentrale für politische Bildung',
        url: 'http://www.bpb.de/shop/lernen/karten/34305/faltkarte-europa',
      },
    ],
  },
  {
    id: 'LE2',
    title: 'Mobilit&auml;t, Flucht und Grundrechte',
    items: [
      {
        type: 'pdf',
        body: 'Informationen zu „Push“- und „Pull“-Faktoren bei Flucht und Migration',
        url: '/downloads/Push_Pull_Definition.pdf',
      },
      {
        type: 'link',
        body: 'Definition Migration',
        url: 'https://e-politik.de/projekte/wissenswerte-infografiken/',
      },
      {
        type: 'pdf',
        body: 'Erklärung der Menschenrechte von den Vereinten Nationen',
        url: 'http://www.un.org/depts/german/menschenrechte/aemr.pdf',
      },
      {
        type: 'link',
        body: 'Flüchtlinge: Definition und Erklärungen der UNHCR',
        url: 'http://www.unhcr.org/dach/de/services/faq/faq-fluechtlinge',
      },
    ],
  },
  {
    id: 'LE3',
    title: 'Einschr&auml;nkung von Freiz&uuml;gigkeit in der DDR',
    items: [
      {
        type: 'link',
        body: 'Geschichte von Wolfgang',
        url: 'http://www.spiegel.de/einestages/fluechtlingsschicksal-a-949975.html',
      },
      {
        type: 'link',
        body: 'Geschichte von Lena',
        url: [
          'https://www.bstu.bund.de/DE/BundesbeauftragterUndBehoerde/Aktuelles/20180216_das_schweigende_klassenzimmer.html',
          'https://www.jugendopposition.de/themen/145437/fuenf-minuten-schweigen-fuer-ungarn',
        ],
      },
      {
        type: 'link',
        body: 'Bericht vom Deutschlandfunk zur Attraktivität von Diktaturen für Kinder und Jugendliche',
        url: 'http://www.deutschlandfunkkultur.de/wenn-die-gespielte-diktatur-wirklichkeit-wird.1216.de.html?dram:article_id=188287',
      },
      {
        type: 'link',
        body: 'Informationen zu den Notaufnahmelagern: Berlin',
        url: 'http://www.notaufnahmelager-berlin.de/de/sonderausstellungen-21.html',
      },
      {
        type: 'link',
        body: 'Informationen zu den Notaufnahmelagern: Marienfelde',
        url: 'http://www.bpb.de/gesellschaft/migration/kurzdossiers/239167/marienfelde?p=all',
      },
    ],
  },
  {
    id: 'LE4',
    title: 'Republikflucht als Verbrechen',
    items: [
      {
        body: 'Zu den Zahlen auf AB4 (Quelle: Bundesausgleichsamt) siehe: Hans-Hermann Hertle, Chronik des Mauerfalls, 8. Aufl., Berlin 1999, S. 320 [12. Aufl., Berlin 2009, S. 344].',
      },
      {
        type: 'link',
        body: 'Stasi-Mediathek',
        url: 'https://www.stasi-mediathek.de',
      },
      {
        type: 'pdf',
        body: 'Stasi-Mediathek: Bericht über die Situation an der Grenze der DDR zur Bundesrepublik im Juli 1961',
        url: 'https://www.stasi-mediathek.de/fileadmin/pdf/dok164.pdf',
      },
      {
        type: 'pdf',
        body: 'Stasi-Mediathek: Bericht über die Entwicklung der Republikflucht 1960',
        url: 'https://www.stasi-mediathek.de/fileadmin/pdf/dok165.pdf',
      },
      {
        type: 'pdf',
        body: 'Stasi-Mediathek: Bericht über Republikfluchten nach dem Bau der Mauer',
        url: 'https://www.stasi-mediathek.de/fileadmin/pdf/dok97.pdf',
      },
      {
        type: 'pdf',
        body: 'Die Methoden der Stasi (BSTU)',
        url: 'https://www.bstu.de/assets/bstu/de/Downloads/schulausstellung_vertiefung-zum-poster_die-methoden-der-stasi.pdf',
      },
      {
        type: 'link',
        body: 'Glossar Rebublikflucht',
        url: 'https://www.bstu.bund.de/SharedDocs/Glossareintraege/DE/R/republikflucht.html',
      },
    ],
  },
  {
    id: 'LE5',
    title: 'Flucht, Opposition oder Arrangement',
    items: [
      {
        type: 'image',
        body: 'Artikel über Rainer Beck vom 20. Okt. 2004',
        url: '/downloads/RainerBeck.jpg',
      },
      {
        type: 'link',
        body: 'Geschichte von Karlheinz Breinig',
        url: 'https://www.zeitzeugenbuero.de/index.php?id=detail&tx_zrwzeitzeugen_zeitzeugen%5Buid%5D=313&tx_zrwzeitzeugen_zeitzeugen%5Bcontroller%5D=Zeitzeugen',
      },
      {
        type: 'link',
        body: 'Artikel über Stefan Wolle im Tagesspiegel vom 26.07.2009',
        url: 'https://www.tagesspiegel.de/politik/abgehauen-in-der-opposition-war-die-ddr-flucht-umstritten/1566028.html',
      },
      {
        type: 'link',
        body: 'Artikel über Rainer Eckart in der Zeit vom Juli 2009',
        url: 'https://www.zeit.de/online/2009/31/ddr-opposition-wende/seite-2',
      },
      {
        type: 'link',
        body: 'Statistik zu Übersiedlern und Flüchtlingen aus der DDR (1961–1990)',
        url: 'http://www.chronik-der-mauer.de/material/178768/uebersiedler-und-fluechtlinge-aus-der-ddr-1961-1990',
      },
    ],
  },
  {
    id: 'LE6',
    title: 'Fluchtwege',
    items: [
      {
        type: 'link',
        body: 'Verschiedene Fluchtgeschichten',
        url: 'http://www.chronik-der-mauer.de/fluchten/',
      },
    ],
  },
  {
    id: 'LE7',
    title: 'Fluchthelfer',
    items: [
      {
        type: 'link',
        body: 'Geschichten der deutsch-deutschen Fluchthilfe in der Online-Ausstellung der Stiftung Berliner Mauer',
        url: 'https://www.risiko-freiheit.de',
      },
      {
        type: 'link',
        body: 'Artikel über Maikes Flucht in der BZ vom 18.12.2005',
        url: 'https://www.bz-berlin.de/artikel-archiv/flucht-mit-kind-im-koffer',
      },
      {
        type: 'video',
        body: 'Musikvideo „Sommer ’89“ von Kettcar auf Youtube',
        url: 'https://www.youtube.com/watch?v=q5qRbbive6o',
      },
    ],
  },
  {
    id: 'LE8',
    title: 'Flucht &uuml;ber die Botschaft in Prag und &Ouml;ffnung der Grenzen',
    items: [
      {
        type: 'link',
        body: 'Die Geschichte von David Altheide im Handelsblatt vom 18.10.2014',
        url: 'http://www.handelsblatt.com/politik/deutschland/mauerfall/ddr-flucht-als-kind-wenn-die-freiheit-nach-joghurt-schmeckt/10844622.html',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/SOURCES.js